import { FormControl, Validators } from '@angular/forms';
import { ContentAssetRule } from '@r1-compass-library/models';

export class ContentLibraryRuleForm {
    name = new FormControl<string>('', { nonNullable: true, validators: Validators.required });
    fieldName = new FormControl<string | undefined>(undefined, { nonNullable: true, validators: Validators.required });
    dataType = new FormControl<string | undefined>(undefined, { nonNullable: true }); // depends if CSV
    not = new FormControl<boolean | null>(null, { nonNullable: true });
    comparator = new FormControl<string | null>(null, { validators: Validators.required });
    value = new FormControl<string | null>(null, { nonNullable: true, validators: Validators.required });
    talkingPointsTemplate = new FormControl<string | null>(null, {
        nonNullable: true,
        validators: Validators.required,
    });

    constructor(rule?: ContentAssetRule) {
        if (rule) {
            this.name.setValue(rule.name || '');
            this.fieldName.setValue(rule.field?.name || undefined);
            this.dataType.setValue(rule.field?.dataType?.toLowerCase() ?? undefined);
            if (rule?.not === true || rule?.not === false) {
                this.not.setValue(rule.not);
            } else {
                this.not.setValue(null);
            }
            this.comparator.setValue(rule.comparator || null);
            if (rule.value) {
                this.value.setValue(rule.value);
            } else {
                this.value.setValue(null);
            }
            this.talkingPointsTemplate.setValue(rule.talkingPointsTemplate || null);
        }
    }
}
